export default class Eigentumsinfo {
    constructor() {
    /** @type {Date}   */
        this.date = new Date();

        /** @type {boolean}  */
        this.isinmutation;

        /** @type {Array}  */
        this.grundstueck;

        /** @type {Array}  */
        this.adressen;

        /** @type {Array}  */
        this.grundstuecke;

        /** @type {?String}  */
        this.pdfuuid;

        /** @type {Object}  */
        this.indexav = {};

        /** @type {Array}  */
        this.eigentuemer = [];

        /** @type {number}   */
        this.stockwerkeigentum = 0;

        /** @type { number }   */
        this.subjdingl = 0;

        /** @type { number }  */
        this.grundstuecksubjdingl = 0;

        /** @type { number }  */
        this.eigentumnormal = 0;
    }
}
